import { SchemaValidationError } from '@toggle/helpers/src/errors';
import { ZodError, ZodIssue, ZodSchema } from 'zod';

export interface ValidateFetcherProps<T> {
  endpoint: string;
  schema?: ZodSchema<T>;
  requestInfo?: RequestInit;
}

export const validateFetcher = async <T>(
  params: ValidateFetcherProps<T>
): Promise<T> => {
  try {
    const res = await fetch(params.endpoint, params.requestInfo);

    // If the status code is not in the range 200-299
    if (!res.ok) {
      throw res;
    }
    const results = await res.json();
    params.schema?.parse(results);
    return results;
  } catch (error) {
    if (error instanceof ZodError) {
      const flattenedError = error.flatten((issue: ZodIssue) => ({
        message: issue.message,
        errorCode: issue.code,
        path: issue.path,
      }));

      throw new SchemaValidationError(params.endpoint, flattenedError);
    }
    throw error;
  }
};
